import React from "react";
import Axios from "axios";
import InputForm from "../../common/InputForm";
import ModalToChange from "../../Layout/ModalToChange";
import { SelectForm } from "../../common/Buttons";
import { comment_type_options } from "../../common/CommentState_type";

const flow_priority_options = [
  { label: "High", value: 1 },
  { label: "Medium", value: 2 },
  { label: "Low", value: 3 },
];

class CommentsStateEdit extends React.Component {
  constructor() {
    super();
    this.state = {
      id: 0,
      name: "",
      color: "#FFFFFF",
      identifier: "",
      comment_type: undefined,
      rivile_service_ids: [],
      flow_priority: undefined,
      ordering: "",
      action: "new",
    };
  }

  loadRivileServicesOptions = async (value) => {
    let query = "";
    if (value && value.length > 0) {
      query = `&q[title_i_cont_any]=${encodeURIComponent(value)}`;
    }

    try {
      const { data } = await Axios.get(
        `/api/v1/rivile_services?page=1&per_page=999999${query}`
      );
      return (data.data || []).map((item) => ({
        value: item.id,
        label: item.title,
      }));
    } catch (_error) {
      return [];
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.action === "new" && this.state.action === "edit") {
      this.setState({
        name: "",
        color: "#FFFFFF",
        identifier: "",
        comment_type: undefined,
        rivile_service_ids: [],
        flow_priority: undefined,
        ordering: "",
        action: "new",
      });
      this.removeErrors(nextProps.errors);
    } else if (
      nextProps.action === "edit" &&
      nextProps.objectData.id !== this.state.id
    ) {
      let item = nextProps.objectData;
      this.setState({
        id: item.value || 0,
        name: item.name || "",
        color: item.color || "#FFFFFF",
        identifier: item.identifier || "",
        comment_type: item.comment_type || undefined,
        rivile_service_ids: item.rivile_service_ids || [],
        flow_priority: item.flow_priority || undefined,
        ordering: item.ordering || "",
        action: "edit",
      });
      this.removeErrors(nextProps.errors);
    }
  }

  removeErrors = (errors) => {
    if (Object.keys(errors).length > 0) {
      this.props.clearErrors();
    }
  };

  handleChange = (e, select) => {
    if (select) {
      this.setState({
        [select]: e,
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  onSubmit = (e) => {
    e.preventDefault();
    const variables = {
      comment_state: {
        name: this.state.name,
        color: this.state.color,
        identifier: this.state.identifier,
        comment_type: this.state.comment_type,
        rivile_service_ids: this.state.rivile_service_ids,
        flow_priority: this.state.flow_priority,
        ordering: this.state.ordering,
      },
    };
    if (this.props.action == "new") {
      this.props.postCommentState(variables);
    } else if (this.props.action === "edit") {
      this.props.updateCommentState(this.state.id, variables);
    }
  };

  render() {

    return (
      <ModalToChange
        handleSave={(e) => this.onSubmit(e)}
        status="tableEdit"
        text={this.props.action === "new" ? "Create new" : "Edit"}
        buttonText={this.props.action === "new" ? "Create" : "Update"}
      >
        <InputForm
          type="text"
          placeholder="Title"
          name="name"
          value={this.state.name}
          error={
            this.props.errors.name &&
            this.props.errors.name.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="color"
          placeholder="Color"
          name="color"
          value={this.state.color}
          onChange={(e) => this.handleChange(e)}
        />
        <InputForm
          type="text"
          placeholder="Identifier"
          name="identifier"
          value={this.state.identifier}
          error={
            this.props.errors.identifier &&
            this.props.errors.identifier.map((item) => `${item} `)
          }
          onChange={(e) => this.handleChange(e)}
        />
        <SelectForm
          options={comment_type_options}
          selector="žinučiu-typas"
          name="comment_type"
          placeholder="Select comment type"
          value={this.state.comment_type}
          onChange={(e) => this.handleChange(e, "comment_type")}
          error={
            this.props.errors.comment_type &&
            this.props.errors.comment_type.map((item) => `${item} `)
          }
        />
        <InputForm
          type="number"
          placeholder="Ordering"
          name="ordering"
          value={this.state.ordering}
          onChange={(e) => this.handleChange(e)}
        />
        <div
          style={{
            backgroundColor: "#f1f3f5",
            borderRadius: "8px",
            padding: "16px",
            marginTop: "16px",
          }}
        >
          <div
            style={{
              color: "#6c757d",
              fontSize: "14px",
              fontWeight: 600,
              marginBottom: "12px",
            }}
          >
            Used for auto comment
          </div>
          <SelectForm
            selector="rivile-services"
            placeholder="Rivile services"
            mode="multiple"
            allowClear={true}
            maxTagCount={5}
            loadOptions={this.loadRivileServicesOptions}
            value={this.state.rivile_service_ids}
            onChange={(e) => this.handleChange(e, "rivile_service_ids")}
            error={
              this.props.errors.rivile_service_ids &&
              this.props.errors.rivile_service_ids.map((item) => `${item} `)
            }
          />
          <SelectForm
            options={flow_priority_options}
            selector="flow-priority"
            name="flow_priority"
            placeholder="Flow priority"
            value={this.state.flow_priority}
            onChange={(e) => this.handleChange(e, "flow_priority")}
            error={
              this.props.errors.flow_priority &&
              this.props.errors.flow_priority.map((item) => `${item} `)
            }
          />
        </div>
      </ModalToChange>
    );
  }
}

export default CommentsStateEdit;
